import React from "react";
import CreatableSelect from "react-select/creatable";
import Select from "react-select";
import { components } from "react-select";
import "../../Style/Components/select.scss";

const CheckboxOption = (props) => {
  return (
    <components.Option {...props}>
      <div className="row" key={props.data.fund_id}>
        <div className="col-11 d-flex align-items-center column-gap-2">
          <img
            style={{ width: "29px" }}
            src={props.data.fund_image}
            alt={props.data.fund_name}
          />
          <p className="e-font-14 e-font-weight-500 e-text-eerie-black e-primary-font-poppins ps-2 m-0">
            {props.data.fund_name}
          </p>
        </div>

        {/* Make checkbox readOnly (react-select controls selection) */}
        <div className="col-1 d-flex align-items-center justify-content-end">
          <input
            type="checkbox"
            id={String(props.data.fund_id)}
            checked={!!props.isSelected}
            readOnly
            className="e-select-menu-input"
          />
        </div>
      </div>
    </components.Option>
  );
};

const InlineMenu = (props) => (
  <components.Menu {...props}>
    <div style={{ position: "static" }}>{props.children}</div>
  </components.Menu>
);

export default function CustomSelectMenu(props) {
  const {
    type = 1,
    options = [],
    value,
    onChange,
    isClearable = true,
    placeholder = props.placeholder || "Select or create....",
    isMulti = true,
  } = props;

  // ensure react-select sees an array for multi selects
  const normalizedValue = isMulti
    ? Array.isArray(value)
      ? value
      : value
      ? [value]
      : []
    : value;

  // tell react-select how to get label/value from your objects
  const getOptionLabel = (opt) => opt?.fund_name ?? opt?.label ?? "";
  const getOptionValue = (opt) =>
    String(opt?.fund_id ?? opt?.value ?? opt?.fund_name ?? opt?.label ?? "");

  if (type === 2) {
    return (
      <Select
        isMulti={isMulti}
        name="select-type-2"
        options={options}
        className="basic-multi-select"
        classNamePrefix="basic-e-multi-select"
        value={normalizedValue}
        onChange={onChange}
        isClearable={isClearable}
        placeholder={placeholder}
        getOptionLabel={getOptionLabel}
        getOptionValue={getOptionValue}
      />
    );
  }
  return (
    <CreatableSelect
      isClearable={isClearable}
      isMulti={isMulti}
      defaultMenuIsOpen={true}
      closeMenuOnSelect={false}
      hideSelectedOptions={false}
      className="e-select-menu-wrapper"
      classNamePrefix="e-select-menu"
      options={options}
      components={{
        Option: CheckboxOption,
        Menu: InlineMenu,
      }}
      value={normalizedValue}
      onChange={onChange}
      placeholder={placeholder}
      getOptionLabel={getOptionLabel}
      getOptionValue={getOptionValue}
    />
  );
}
